import { clsx, type ClassValue } from 'clsx';

/**
 * Tiny className combiner. Use whenever you build conditional class strings.
 *   cn('btn', isPrimary && 'btn-primary', disabled && 'opacity-50')
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
